import { makeHttpRequest } from "@/shared";

export const deleteExpenses = async (ids) => {
    const response = (
        await makeHttpRequest({
            url: "/expense/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;

    return response;
};
